import React from 'react';

interface ToastHUDProps {
  message: string;
  type: 'success' | 'error';
}

export const ToastHUD: React.FC<ToastHUDProps> = ({ message, type }) => {
  return (
    <div className={`pwa-toast-hud ${type === 'error' ? 'pwa-toast-error' : 'pwa-toast-success'}`}>
      {message}
    </div>
  );
};
